import * as types from "../actions/actionTypes";

const initialState = {
  addresses: [],
  address: null,
};

const address = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_ADDRESS_RESPONSE:
      return { ...state, addresses: action.payload };
    case types.GET_ADDRESS_RESPONSE:
      return { ...state, addresses: action.payload };
    case types.GET_ADDRESS_RESPONSE:
      return { ...state, addresses: action.payload };

    case types.CREATE_ADDRESS:
      return { ...state, address: null };
    case types.UPDATE_ADDRESS:
      return { ...state, address: null };
    case types.DELETE_ADDRESS:
      return { ...state, address: null };
    default:
      return state;
  }
};

export default address;
